import { Department } from '../types';

export enum DepartmentActionType {
    GET_ALL_DEPARTMENTS = 'GET_ALL_DEPARTMENTS',
    GET_DEPARTMENT = 'GET_DEPARTMENT',
    CREATE_DEPARTMENT = 'CREATE_DEPARTMENT',
    UPDATE_DEPARTMENT = 'UPDATE_DEPARTMENT',
    DELETE_DEPARTMENTS = 'DELETE_DEPARTMENTS',
    MERGE_DEPARTMENTS = 'MERGE_DEPARTMENTS',
}

interface GetAllDepartmentsAction {
    type: DepartmentActionType.GET_ALL_DEPARTMENTS;
    payload: Array<Department>;
}

interface GetDepartmentAction {
    type: DepartmentActionType.GET_DEPARTMENT;
    payload: Department;
}

interface CreateDepartmentAction {
    type: DepartmentActionType.CREATE_DEPARTMENT;
    payload: Department;
}

interface UpdateDepartmentAction {
    type: DepartmentActionType.UPDATE_DEPARTMENT;
    payload: Department;
}

interface DeleteDepartmentsAction {
    type: DepartmentActionType.DELETE_DEPARTMENTS;
    payload: Array<Department>;
}

interface MergeDepartmentsAction {
    type: DepartmentActionType.MERGE_DEPARTMENTS;
    payload: Array<Department>;
}

export type DepartmentAction =
    | GetAllDepartmentsAction
    | GetDepartmentAction
    | CreateDepartmentAction
    | UpdateDepartmentAction
    | DeleteDepartmentsAction
    | MergeDepartmentsAction;
